import { createSelector } from "reselect";
import { Utilities } from "@learningblocks/exp-constants";

const { NOTEBOOK } = Utilities;

const totalNodeComponents = (state) => {
  // currentView contains the view data directly
  return state.designChapter?.currentView?.totalNodeComponents || 0;
};

const correctNodeComponents = (state) => {
  // currentView contains the view data directly
  return state.designChapter?.currentView?.correctNodeComponents || 0;
};

const showFeedback = (state) => {
  // currentView contains the view data directly
  return state.designChapter?.currentView?.showFeedback || false;
};

const isInDesignSection = (state) => {
  // Check if we're currently in a design section
  const currentMenu = state.menuList?.find(menu => menu.current);
  return currentMenu?.value === NOTEBOOK.SECTION.DESIGN;
};

export const getIsModalOpen = createSelector(
  [correctNodeComponents, totalNodeComponents, showFeedback, isInDesignSection],
  (correctNodeComponents, totalNodeComponents, showFeedback, isInDesignSection) => {
    // Only show modal if we're in a design section AND the completion conditions are met
    if (isInDesignSection && showFeedback && totalNodeComponents === correctNodeComponents && totalNodeComponents > 0)
      return true;
    else return false;
  }
);
